// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"da90483a","513":"6f301c3d","703":"51c54467"}[chunkId] + ".chunk.js";
};